import DOMPurify from 'dompurify';
import {uploadFile} from '../../redux/user/userActions.js';
import {cleanText, SANITIZE_CONFIG} from './TextEditorHelpers.js';
import ReactQuill from 'react-quill';

export const handlePaste = (e, quillRef, maxChar) => {
    if(!quillRef.current) return;
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData('text/html') || clipboardData.getData('text');
    const cleanData = cleanText(pastedData);

    const sanitizedData = DOMPurify.sanitize(cleanData, SANITIZE_CONFIG);
    const editor = quillRef.current.getEditor();
    if(!editor) return;
    const currentText = editor.getText();
    const selection = editor.getSelection(true);
    const replacementLength = selection ? selection?.length : 0;
    const futureLength = currentText.length - replacementLength + (sanitizedData.replace(/<[^>]*>/g, '').length);

    if(futureLength > maxChar) {
        e.preventDefault();
    } else {
        e.preventDefault();
        let processedData = sanitizedData;
        if(clipboardData.getData('text/html')) {
            processedData = processedData.replace(/<p><\/p>/g, '<p><br></p>');
        } else {
            const parts = processedData.split(/\n\n/);
            processedData = parts.map(part => {
                const lines = part.split(/\n/);
                return lines.map(line => `<p>${line}</p>`).join('');
            }).join('<p><br></p>');
        }
        
        if(selection) {
            editor.deleteText(selection?.index, selection?.length);
            editor.clipboard.dangerouslyPasteHTML(selection?.index, processedData, 'user');
            const pastedLength = processedData.replace(/<[^>]*>/g, '').length;
            editor.setSelection(selection?.index + pastedLength, 0);
        } else {
            const cursorPosition = editor.getSelection()?.index;
            editor.clipboard.dangerouslyPasteHTML(cursorPosition, processedData, 'user');
            const pastedLength = processedData.replace(/<[^>]*>/g, '').length;
            editor.setSelection(cursorPosition + pastedLength, 0);
        }
    }
};

// Simple function to insert image into Quill
export const insertImage = (quill, url) => {
    if(!quill || !url) return;
    const range = quill.getSelection(true);
    quill.insertEmbed(range.index, 'image', url, 'user');
    quill.setSelection(range.index + 1);
};

export const createImageHandler = (quillRef) => {
    return () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if(!file) return;
            
            const quill = quillRef.current?.getEditor();
            if(!quill) return;
            
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const uploadedUrl = await uploadFile(e.target.result, file.type, 'textEditorImage');
                    if(uploadedUrl) {
                        insertImage(quill, uploadedUrl);
                    } else {
                        console.log('Image upload failed');
                    }
                } catch (error) {
                    console.log('Error uploading image:', error);
                }
            };
            reader.readAsDataURL(file);
        };
    };
};

export const handleCopy = (e, quillRef) => {
    if(!quillRef.current) return;
    const Quill = ReactQuill.Quill;
    const editor = quillRef.current.getEditor();
    if(!editor) return;
    const selection = editor.getSelection();
    
    if(selection && selection.length > 0) {
        const range = editor.getSelection();
        const delta = editor.getContents(range.index, range.length);
        const container = document.createElement('div');
        document.body.appendChild(container);
        const tempQuill = new Quill(container, {theme: 'snow'});
        tempQuill.setContents(delta);
        const html = container.querySelector('.ql-editor').innerHTML;
        document.body.removeChild(container);
        e.clipboardData.setData('text/html', html);
        e.clipboardData.setData('text/plain', editor.getText(range.index, range.length));
        e.preventDefault();
    }
};

